import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';

import { AuthFacade } from '../state/auth.facade';

export const authGuard: CanActivateFn = (route, state) => {
    const authFacade = inject(AuthFacade);

    return authFacade.isAuthenticated$.pipe(
        map((isAuthenticated) => {
            if (!isAuthenticated) {
                authFacade.navigateToLogin(state.url);

                return false;
            }

            return true;
        })
    );
};
